<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="loading==0 && loadedNodes.length!=0">
  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef matTooltip="Material code of the component">
      <span [style.paddingLeft.px]="40"><strong> Material code</strong> </span>
    </th>
    <td mat-cell *matCellDef="let data">
      <button mat-icon-button [style.visibility]="!data.expandable ? 'hidden' : ''"
        [style.marginLeft.px]="data.level * 32" (click)="treeControl.toggle(data)">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>

      {{data.code}}
    </td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef matTooltip="Component description">
      <strong> Description </strong>
    </th>
    <td mat-cell *matCellDef="let data"> {{data.description}} </td>
  </ng-container>

  <ng-container matColumnDef="serial-number">
    <th mat-header-cell *matHeaderCellDef matTooltip="Serial number of traceable component">
      <strong> Serial number </strong>
    </th>
    <td mat-cell *matCellDef="let data"> {{data.serialNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="controls">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let data">
      <a mat-raised-button color="primary" routerLink="/traceable-component/{{source}}/{{data.id}}">
        <mat-icon>info</mat-icon>
        Details
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<loading-bar *ngIf="loading!=0"></loading-bar>

<p *ngIf="loading==0 && loadedNodes.length==0">
  <strong>Traceable components not found for given asset and source</strong>
</p>